import { stateStatusType, RoleProps } from './actionType';

export interface FetchRolestate {
    isLoading: boolean;
    error: string | null;
    roles: RoleProps[] | null;
    status: stateStatusType | null;
    delete: string| null
}
export interface GenericRolestate {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
    data: RoleProps | null;
}

export const initialFetchRolestate: FetchRolestate = {
    isLoading: false,
    error: null,
    roles: null,
    status: null,
    delete: null
};
export const initialGenericRolestate: GenericRolestate = {
    isLoading: false,
    error: null,
    status: null,
    data: null
};

export interface RolesState {
    fetchRolesState: FetchRolestate;
    genericRoleState: GenericRolestate
}

export const initialState: RolesState = {
    fetchRolesState: initialFetchRolestate,
    genericRoleState: initialGenericRolestate
};
